import { colors, Typography } from '@sweep-io/sweep-design';
import { PromptGroup } from '@server/prompts';
import { StyledCard, PromptGroupCardContent } from './PromptGroupCardContent';
import { PromptLibraryIcon } from '../../promptsLibrary/PromptLibraryIcon';

interface PromptCardProps {
  promptGroup: PromptGroup;
  onClick: (promptCard: PromptGroup) => void;
  isMinimized: boolean;
}

export const PromptCard = ({ promptGroup, onClick, isMinimized }: PromptCardProps) => {
  const { iconName: icon, name } = promptGroup;

  if (isMinimized) {
    return (
      <StyledCard
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        onClick={() => onClick(promptGroup)}
      >
        <PromptLibraryIcon icon={icon} />
        <Typography variant="caption" whiteSpace="nowrap" color={colors.grey[700]}>
          {name}
        </Typography>
      </StyledCard>
    );
  }

  return <PromptGroupCardContent onClick={onClick} promptGroup={promptGroup} />;
};
